export default __webpack_public_path__ + "static/media/Avia.f48ba4d0.png";